<template>
  <v-card class="rounded-4" :loading="loading">
    <v-card-title class="section-title pb-0">
      <v-layout justify-space-between align-center>
        <span>{{ title }}</span>
        <v-btn v-if="to && !$slots['title-action']" icon small class="pa-0" :to="to">
          <v-icon size="30">mdi-chevron-right</v-icon>
        </v-btn>
        <slot v-else-if="$slots['title-action']" name="title-action" />
      </v-layout>
    </v-card-title>

    <v-card-subtitle v-if="subtitle" class="pt-1">{{ subtitle }}</v-card-subtitle>

    <v-card-text v-if="!noContent">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    to: {
      type: Object,
    },
    noContent: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped></style>
